import { useSelector } from 'react-redux';
import Login from './screens/Auth/Login';
import ForgotPassword from './screens/Auth/ForgotPassword';
import ForgotPasswordOtp from './screens/Auth/ForgotPasswordOtp';
import ResetPassword from './screens/Auth/ResetPassword';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HeaderProvider } from './context/HeaderContext';
import { useState } from 'react';
import PartnerSidebar from './components/Sidebar/PartnerSidebar';
import PartnerHeader from './components/Sidebar/PartnerHeader';
import Dashboard from './screens/Dashboard/Dashboard';
import ActiveCampaigns from './screens/Campaigns/ActiveCampaigns';
import PastCampaigns from './screens/Campaigns/PastCampaigns';
import NewCampaignRequestList from './screens/Campaigns/NewCampaignRequestList';
import ModificationRequestList from './screens/Campaigns/ModificationRequestList';
import CreateCampaignRequest from './screens/Campaigns/CreateCampaignRequest';
import CreateModificationRequest from './screens/Campaigns/CreateModificationRequest';
import CampaignDetails from './screens/Campaigns/CampaignDetails';
import NewCampaignRequestDetails from './screens/Campaigns/NewCampaignRequestDetails';
import ModificationRequestDetails from './screens/Campaigns/ModificationRequestDetails';
import SupportTicketList from './screens/Support/SupportTicketList';
import CreateSupportTicket from './screens/Support/CreateSupportTicket';
import TicketDetails from './screens/Support/TicketDetails';
import Profile from './screens/Settings/Profile';
import ChangePassword from './screens/Settings/ChangePassword';
import DocumentRepository from './screens/Documents/DocumentRepository';
import './App.css';

function App() {
  const partnerState = useSelector((state) => state.partner);

  const [activeItem, setActiveItem] = useState("dashboard");
  const [selectedTab, setSelectedTab] = useState("dashboard");

  return (
    <div className="App flex">
      <BrowserRouter>
        <HeaderProvider>
          {partnerState.isLoggedIn ? (
            <div className="w-full min-h-screen flex flex-col">
              <PartnerHeader />
              <div className="app-main flex justify-between w-full">
                <PartnerSidebar
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                />
                <div
                  className="ml-64 w-full mt-5 mb-5 px-4"
                  style={{ width: "-webkit-fill-available" }}
                >
                  <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/dashboard' element={<Dashboard />} />

                    {/* Campaign Routes */}
                    <Route path='/campaigns/active' element={<ActiveCampaigns />} />
                    <Route path='/campaigns/past' element={<PastCampaigns />} />
                    <Route path='/campaigns/new-req' element={<NewCampaignRequestList />} />
                    <Route path='/campaigns/new-req/create' element={<CreateCampaignRequest />} />
                    <Route path='/campaigns/new-req/:id' element={<NewCampaignRequestDetails />} />
                    <Route path='/campaigns/mod-req' element={<ModificationRequestList />} />
                    <Route path='/campaigns/mod-req/create' element={<CreateModificationRequest />} />
                    <Route path='/campaigns/mod-req/:id' element={<ModificationRequestDetails />} />
                    <Route path='/campaigns/details/:id' element={<CampaignDetails />} />

                    {/* Document Routes */}
                    <Route path='/documents' element={<DocumentRepository />} />

                    {/* Support Routes */}
                    <Route path='/support' element={<SupportTicketList />} />
                    <Route path='/create-support-ticket' element={<CreateSupportTicket />} />
                    <Route path='/ticket-details/:id' element={<TicketDetails />} />

                    {/* Settings Routes */}
                    <Route path='/settings/profile' element={<Profile />} />
                    <Route path='/settings/change-password' element={<ChangePassword />} />

                    {/* Fallback */}
                    <Route path='*' element={<Navigate to="/" replace />} />
                  </Routes>
                </div>
              </div>
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/forgotpasswordotp" element={<ForgotPasswordOtp />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}
        </HeaderProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
